import React from 'react'

type Props = {
  title: string
  description?: string
  subTitle?: string
  children?: React.ReactNode
  itemsCount?: number
  search?: any
  hideSearchBar?: boolean
}

export const OrderCardHeader: React.FC<Props> = ({
  title,
  description,
  subTitle,
  children,
  itemsCount,
  search,
  hideSearchBar,
}) => {
  return (
    <>
      <div className='card-header pt-5 w-100'>
        <div className='d-flex align-items-center position-relative my-1 w-100 '>
          {title && (
            <h3 className='card-title align-items-start flex-column w-100'>
              <span className='card-label mb-1'>
                <div className='d-flex align-items-center mb-0 pb-0'>
                  {title}
                  {itemsCount && itemsCount > 0 ? (
                    <span className='badge badge-light ms-3'>{itemsCount}</span>
                  ) : null}
                </div>
              </span>
              {description && <div className='text-dark mt-3 fw-bold fs-7'>{description}</div>}
              {subTitle && <span className='text-muted mt-1 fw-bold fs-7'>{subTitle}</span>}
              {!hideSearchBar && <>{search}</>}
            </h3>
          )}
          {children && <div className='card-toolbar'>{children}</div>}
        </div>
      </div>
    </>
  )
}

export default OrderCardHeader
